export default __webpack_public_path__ + "static/SFMono-RegularItalic-a596917f86217b40000ff1b894cd0e52.woff2";